import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import format from 'format-number';
import { FormatNumber } from '../../../utils/FormatFields';

class LoansField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loans: format({})(this.props.loans)
    };

    this.onChange = this.onChange.bind(this);
  }
  componentDidUpdate(prevProps) {    
    if(prevProps.loans !== this.props.loans) {    
      this.setState({
        loans: format({})(this.props.loans)
      })
    }
  }
  onChange(event) {
    FormatNumber(event.target.value, (value) => {
      this.setState({
        [event.target.name]:format({})(value)
      });
      this.props.handleChange({target: {
          name: [event.target.name],
          value: value
        }
      });
    });
  }
  render() {
    return (
      <div>
        <FormGroup>
          <Label for="loans">Loans or Lines of Credit</Label>
          <div className={`expense-input ${(this.props.error ? 'invalid' : '')}`}>
            <Input type="tel" name="loans" id="loans" value={this.state.loans} onChange={this.onChange} invalid={this.props.error} onBlur={this.props.onBlur} autoFocus={this.props.autoFocus} />
            <FormFeedback hidden={!this.props.error}>{this.props.errorMessage}</FormFeedback>
          </div>
        </FormGroup>                                                 
      </div>);
  }
}
LoansField.defaultProps= {
  handleChange:() => {},
  error: false,
  errorMessage: "",
  autoFocus: false
};

LoansField.propTypes = {
  handleChange: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  autoFocus: PropTypes.bool
};

export default LoansField;


// WEBPACK FOOTER //
// ./src/components/Fields/IncomeExpenses/LoansField.js